import React from "react"
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import Layout from "../../../components/layout/Layout";
import {useHistory} from "react-router-dom";

export const Error404 = () => {
    const history = useHistory();
    return (
        <Layout>
            <div className="u_account-form">
                <Commonrightcircle/>
                <div className="u_error-page u_mb-30">
                    <img src="/images/images/error_404.png" alt="OOPS! PAGE NOT FOUND"/>
                    <h2 className="u_mb-30">OOPS! PAGE NOT FOUND</h2>
                    <button type="button" onClick={() => history.push("/login")}
                            className="u_account-btn u_w-full u_cp">Login
                    </button>
                </div>
            </div>
        </Layout>
    );
}